// extracted by mini-css-extract-plugin
export var container = "_4y-0";
export var disabled = "_4y-4";
export var fullWidth = "_4y-3";
export var lined = "_4y-1";
export var selected = "_4y-5";
export var tab = "_4y-2";